export interface IQuery { }

export class CorporateScenarioPnlQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.CorporateScenarioPnlQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string
	ApplyBenefitsConfidenceFactor: boolean
	PnlTemplateId: string
	Denomination: any

	constructor (workspaceId: number, strategyId: string, scenarioId: string, applyBenefitsConfidenceFactor: boolean, pnlTemplateId: string, denomination: any)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
		this.ApplyBenefitsConfidenceFactor = applyBenefitsConfidenceFactor
		this.PnlTemplateId = pnlTemplateId
		this.Denomination = denomination
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.CorporateScenarioPnlQueryV1, TCh.Domain.Quest'
	}

}

export class PnlPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.PnlPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string

	constructor (workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.PnlPageQueryV1, TCh.Domain.Quest'
	}

}

export class PortfoliosPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.PortfoliosPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string

	constructor (workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.PortfoliosPageQueryV1, TCh.Domain.Quest'
	}

}

export class ProjectsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.ProjectsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string

	constructor (workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.ProjectsPageQueryV1, TCh.Domain.Quest'
	}

}

export class ScenariosPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.ScenariosPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string

	constructor (workspaceId: number, strategyId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.ScenariosPageQueryV1, TCh.Domain.Quest'
	}

}

export class SchedulingPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.SchedulingPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string

	constructor (workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.SchedulingPageQueryV1, TCh.Domain.Quest'
	}

}

export class SchedulingSettingsQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.SchedulingSettingsQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string

	constructor (workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.SchedulingSettingsQueryV1, TCh.Domain.Quest'
	}

}

export class SettingsPageQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Quest.CorporateScenarios.Queries.SettingsPageQueryV1, TCh.Domain.Quest'

	WorkspaceId: number
	StrategyId: string
	ScenarioId: string

	constructor (workspaceId: number, strategyId: string, scenarioId: string)
	{
		this.WorkspaceId = workspaceId
		this.StrategyId = strategyId
		this.ScenarioId = scenarioId
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Quest.CorporateScenarios.Queries.SettingsPageQueryV1, TCh.Domain.Quest'
	}

}

